function alert(field, message, style) {
    if (message) { // add an "alert" message below the field
        const alertEl = document.createElement('small');
        alertEl.classList.add('text-warning');
        alertEl.setAttribute('role', 'alert');
        alertEl.innerHTML = message;

        let next = field.parentElement.querySelector('[role=alert]:last-child');
        if (next) next = next.nextSibling;

        if (next) {
            field.parentElement.insertBefore(alertEl, next);
        } else {
            field.parentElement.appendChild(alertEl);
        }

        if (style) alertEl.classList.add(style);

        field.setAttribute('aria-alert', true);

        return alertEl;
    }
    // remove all existing alert messages
    field.removeAttribute('aria-alert');
    Array.prototype.forEach.call(field.parentElement.querySelectorAll('[role=alert]:last-child'), (el) => {
        el.parentNode.removeChild(el);
    });

}

/**
 * Determine if the field or form is valid.
 *
 * @param  {HTMLElement} field
 *         An input field to validate.
 *         If a form is provided all fields are checked.
 *
 * @return {[type]}
 *         true if the field appears valid
 */
function validate(field) {
    if (field.tagName.toLowerCase() === 'form') {
        let idx;
        for (idx = 0; idx < field.elements.length; idx++) {
            if (!validate(field.elements[idx])) return false;
        }
        return true;
    }

    if (field.getAttribute('type') === 'date') {

        if (field.value) {
            if (Number.isNaN(Date.parse(field.value))) {
                return false;
            }

            let matches;
            if (/\d{4}-\d{2}-\d{2}/.exec(field.value)) {
                // continue
            } else if ((matches = /(\d{2})\/(\d{2})\/(\d{4})/.exec(field.value))) {
                const ymd = ([matches[3], matches[2], matches[1]]).join('-');
                if (Number.isNaN(Date.parse(ymd))) return false;
                field.value = ymd;
            } else {
                return false;
            }

        }

        const val = new Date(field.value);
        let min = field.getAttribute('min');
        let max = field.getAttribute('max');
        if (!min && !max) return;
        min = min && new Date(min);
        max = max && new Date(max);
        if (min && val < min) return false;
        if (max && max < val) return false;
    }

    if (field.hasAttribute('required')) {
        if (field.value === '') return false;
        if (field.type === 'date' && !field.value.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return false;
        }
    }

    return true;
}

window.field = {
    alert,
    validate,
};
